"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.NuclearPower = void 0;
var Tags_1 = require("../Tags");
var Card_1 = require("../Card");
var CardType_1 = require("../CardType");
var Resources_1 = require("../../Resources");
var CardName_1 = require("../../CardName");
var CardRenderer_1 = require("../render/CardRenderer");
var Units_1 = require("../../Units");
var NuclearPower = (function (_super) {
    __extends(NuclearPower, _super);
    function NuclearPower() {
        return _super.call(this, {
            cardType: CardType_1.CardType.AUTOMATED,
            name: CardName_1.CardName.NUCLEAR_POWER,
            tags: [Tags_1.Tags.ENERGY, Tags_1.Tags.BUILDING],
            cost: 10,
            productionBox: Units_1.Units.of({ energy: 3, megacredits: -2 }),
            metadata: {
                cardNumber: '045',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.production(function (pb) {
                        pb.minus().megacredits(2).br;
                        pb.plus().energy(3);
                    });
                }),
                description: 'Decrease your M€ production 2 steps and increase your Energy production 3 steps.',
            },
        }) || this;
    }
    NuclearPower.prototype.canPlay = function (player) {
        return player.getProduction(Resources_1.Resources.MEGACREDITS) >= -3;
    };
    NuclearPower.prototype.play = function (player) {
        if (player.getProduction(Resources_1.Resources.MEGACREDITS) < -3) {
            throw 'Not enough M€ production';
        }
        player.addProduction(Resources_1.Resources.MEGACREDITS, -2);
        player.addProduction(Resources_1.Resources.ENERGY, 3);
        return undefined;
    };
    return NuclearPower;
}(Card_1.Card));
exports.NuclearPower = NuclearPower;
